var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19922 6.33366C1.19922 6.00033 0.199219 5.33366 0.199219 2.00033C0.199219 1.00033 1.19922 0.666992 2.19922 0.666992C3.53255 0.666992 3.19922 1.00033 4.19922 1.00033C5.19922 1.00033 4.86589 0.666992 6.19922 0.666992C7.19922 0.666992 8.19922 1.00033 8.19922 2.00033C8.19922 5.33366 7.19922 6.00033 7.19922 6.33366C6.86589 9.33366 7.19922 6.33366 6.86589 9.33366C6.53255 11.0003 6.19922 11.3337 5.86589 11.3337C5.53255 11.3337 5.19922 9.66699 5.19922 9.33366C5.19922 9.00033 4.86589 6.66699 4.19922 6.66699C3.53255 6.66699 3.19922 9.00033 3.19922 9.33366C3.19922 9.66699 2.86589 11.3337 2.53255 11.3337C2.19922 11.3337 1.86589 11.0003 1.53255 9.33366C1.19922 6.33366 1.53255 9.33366 1.19922 6.33366Z",
    fill: "#4338CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.a5e1292ad87ee41b487e1aa70cf01422.svg";
export { ForwardRef as ReactComponent };